import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Tooltip, Typography } from '@mui/material'
import React, { useEffect } from 'react'
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import SearchIcon from '@mui/icons-material/Search';
// import VisibilityIcon from '@mui/icons-material/Visibility';
// import DashboardIcon from '@mui/icons-material/Dashboard';
// import DeleteIcon from '@mui/icons-material/Delete';
import Service from '../Networking/NetworkingUtils';
import { getCookie } from '../Utils/CookieHelper';
import { useSnackbar } from 'notistack';
import Blob from '../Blob';

var token = getCookie("bb_metaverse_token");
var user = JSON.parse(getCookie("bb_metaverse_user"))



const WebglUpload = (props) => {

    const [loading, setLoading] = React.useState(true)
    const { enqueueSnackbar } = useSnackbar();
    const [tableData, setTableData] = React.useState([{ name: 'Sample Asset 1', description: 'This is a sample asset', key: 'asset_001' },])
    const [columns] = React.useState([
        { title: 'Version Name', field: 'version_name', },
        { title: 'Version Code', field: 'version_code', },
        { title: 'Version', field: 'version', },
        { title: 'Change Log', field: 'change_log', },
    ])
    const [addDialog, setAddDialog] = React.useState(false)
    const [newData, setNewData] = React.useState({})
    const [oldData, setOldData] = React.useState({})
    const [editOpen, setEditOpen] = React.useState(false)
    const [openUpload, setOpenUpload] = React.useState(false)
    const [selectedRow, setSelectedRow] = React.useState(null)
    // const [plannerDialog, setPlannerDialog] = React.useState(false)
    // const [version, setVersion] = React.useState({})
    // const [deleteDialog, setDeleteDialog] = React.useState(false)
    // const [deleteData, setDeleteData] = React.useState(null)
    const [addDisabled, setAddDisabled] = React.useState(false)
    const [editDisabled, setEditDisabled] = React.useState(false)
    const [versionNames, setVersionNames] = React.useState([])
    const [versionCodes, setVersionCodes] = React.useState([])
    const [search, setSearch] = React.useState('')



    const editVersion = () => {
        if (!newData.version_name  || !newData.version) {
            enqueueSnackbar('Version Version Head are mandatory fields!', {
                variant: 'warning'
            });
        } else if ((newData.version_name !== oldData.version_name) && (versionNames.includes(newData.version_name.trim()))) {
            enqueueSnackbar('Version is already exits!', {
                variant: 'warning'
            })
        } else if ((parseInt(newData.version_code) !== oldData.version_code) && (versionCodes.includes(parseInt(newData.version_code)))) {
            enqueueSnackbar('Version code is already exits!', {
                variant: 'warning'
            })
        } else {
            setEditDisabled(true)
            setLoading(true)
            let data = {
                created_by: user.id,
                version_name: newData.version_name.trim(),
                version_code: newData.version_code,
                version: newData.version,
                asset_source: newData.asset_source,
                change_log: newData.change_log,
                id: newData.id
            }
            Service.patch('/api/webgl/template/edit_webgl_template/', {
                headers: {
                    Authorization: "Token " + token,
                },
                data: data
            }).then(res => {
                getData()
                setNewData(null)
                setOldData(null)
                setEditOpen(false)
                enqueueSnackbar('version edited Successfully!', {
                    variant: 'success'
                })
                setEditDisabled(false)
            }).catch(error => {
                console.log(error)
                enqueueSnackbar('Something went wrong!', {
                    variant: 'error'
                })
                setEditDisabled(false)
            })
        }

    }


    // function deleteFiles(row) {
    //     // API call to delete the file
    // }

    function addVersion() {
        setAddDisabled(true)
        let data = newData
        data['object_source'] = null
        data['created_by'] = user.id
        data['updated_by'] = user.id
        Service.post(`/api/webgl/template/create_webgl_template/`, {
            headers: {
                Authorization: "Token " + token,
            },
            data: data,
        })
            .then(res => {
                setLoading(true)
                getData()
                setAddDialog(false)
                setAddDisabled(false)
                enqueueSnackbar('Version added successfully!', {
                    variant: 'success'
                });
            })
            .catch(error => {
                console.log(error)
                enqueueSnackbar('Something went wrong!', {
                    variant: 'error'
                });
            });
    }

    const handleAddDialog = () => {
        setAddDialog(false)
    }

    // const handleVersionChange = (event) => {
    //     setNewData({ ...newData, ...{ 'version_head': event.target.value } })
    // };


    const handleVersionHeadChange = (event) => {
        setNewData({ ...newData, ...{ [event.target.id]: event.target.value } })
    };

    function getData() {
        Service.get(`/api/webgl/template/get_webgl_template/`, {
            headers: {
                Authorization: "Token " + token,
            },
        })
            .then(res => {
                for (let i = 0; i < res.data.length; i++) {
                    const element = res.data[i];
                    if (element) {
                        versionNames.push(element.version)
                        versionCodes.push(element.version_code)
                    }
                }
                setVersionNames(versionNames)
                setVersionCodes(versionCodes)
                setTableData(res.data)
                setLoading(false)
            })
            .catch(error => {
                console.log(error)
                enqueueSnackbar('Something went wrong!', {
                    variant: 'error'
                });
            });
    }

    useEffect(() => {
        getData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const UpdateBlob = (data, row) => {
        if (row && data.length > 0) {
            row.object_source = data.join()
            Service.patch('/api/webgl/template/edit_webgl_template/', {
                headers: {
                    Authorization: "Token " + token,
                },
                data: row
            }).then(res => {
                getData()
                enqueueSnackbar('Blob uploaded sucessfully!', {
                    variant: 'success'
                })
                setOpenUpload()
            }).catch(error => {
                console.log(error)
                enqueueSnackbar('Something went wrong!', {
                    variant: 'error'
                })
            })
        }
    }

    const handleClose = () => {
        setOpenUpload(false)
    }

    const closeEditDialog = () => {
        setNewData(null)
        setOldData(null)
        setEditOpen(false)
    }

    const filteredTableData = tableData.filter(row =>
        columns.some(column => String(row[column.field] || '').toLowerCase().includes(search.toLowerCase()))
    )


    return (
        <div> {loading ? <Box display='flex' justifyContent={'center'} alignItems={'center'} width='100%'><CircularProgress /></Box> :
            <div>
                <TableContainer component={Paper}>
                    <Box width='100%' display='flex' justifyContent='space-between' alignItems='center' padding='14px 16px 10px'>
                        <Typography
                            variant="h6"
                            sx={{
                                fontWeight: 700,
                                fontSize: 20,
                                color: 'text.primary',
                            }}
                        >
                            WebGL Templates
                        </Typography>
                        <Box display='flex' alignItems='center' gap={1}>
                            <TextField
                                size='small'
                                variant='outlined'
                                placeholder='Search'
                                value={search}
                                onChange={(event) => setSearch(event.target.value)}
                                InputProps={{ endAdornment: <SearchIcon /> }}
                            />
                            <Tooltip title="Add"><span><IconButton onClick={() => { setAddDialog(true) }}><AddIcon /></IconButton></span></Tooltip>
                        </Box>
                    </Box>
                    <Table>
                        <TableHead>
                            <TableRow>
                                {columns && columns.map((column) => (
                                    <TableCell key={column.field}>{column.title}</TableCell>
                                ))}
                                {props?.data?.program_directory ? <TableCell /> :
                                    <TableCell>Actions</TableCell>}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {filteredTableData && filteredTableData.map((row) => (
                                <React.Fragment key={row.id}>
                                    <TableRow>
                                        {columns && columns.map((column) => (
                                            <TableCell key={column.field}  >
                                                {column.lookup ? column.lookup[row[column.field]] : row[column.field]}
                                            </TableCell>
                                        ))}
                                        {props?.data?.program_directory ? null :
                                            <TableCell display='flex' justifyContent='space-evenly' alignItems='center'>
                                                <Tooltip title="Edit"><span><IconButton onClick={() => { setNewData(row); setOldData(row); setEditOpen(true) }}><EditIcon /></IconButton></span></Tooltip>
                                                <Tooltip title="Upload"><span><IconButton disabled={row.asset_source} onClick={() => { setSelectedRow(row); setOpenUpload(true) }}><FileUploadIcon /></IconButton></span></Tooltip>
                                                {/* <Tooltip title="View File Path"><span><IconButton onClick={() => { handleFilePath(row.asset_source) }}><VisibilityIcon /></IconButton></span></Tooltip> */}
                                                {/* <Tooltip title="View Planner"><span><IconButton onClick={() => { setPlannerDialog(true); setVersion(row) }}><DashboardIcon /></IconButton></span></Tooltip> */}
                                                {/* <Tooltip title="Delete"><span><IconButton onClick={() => { if (row.is_deletable) { deleteFiles(row) } else { setDeleteData(row); setDeleteDialog(true) } }}><DeleteIcon /></IconButton></span></Tooltip> */}
                                            </TableCell>
                                        }
                                    </TableRow>
                                    <TableRow>
                                        <TableCell sx={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                                            {/* <Collapse in={row.open} timeout="auto" unmountOnExit>
                                                    <Box sx={{ margin: 1 }}>
                                                        <UserPermission value={row} />
                                                    </Box>
                                                </Collapse> */}
                                        </TableCell>
                                    </TableRow>
                                </React.Fragment>

                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                <Dialog maxWidth="sm" fullWidth={true} open={addDialog} onClose={handleAddDialog}>
                    <DialogTitle marginTop="2px" spacing={2}>Add Version</DialogTitle>
                    <DialogContent>
                        <Box>
                            <TextField
                                id='version'
                                fullWidth
                                autoComplete="off"
                                variant="outlined"
                                label="Version"
                                onChange={handleVersionHeadChange}
                                // defaultValue={newData?.version}
                                sx={{ marginBottom: "10px" }} />
                            <TextField
                                id='version_name'
                                fullWidth
                                autoComplete="off"
                                variant="outlined"
                                label="Version Name"
                                onChange={handleVersionHeadChange}
                                // defaultValue={newData?.version}
                                sx={{ marginBottom: "10px" }} />
                            {/* <FormControl variant="outlined" fullWidth>
                                <InputLabel id="version_head">Version Head</InputLabel>
                                <Select
                                    variant="outlined"
                                    labelId="demo-simple-select-label"
                                    id="version_head"
                                    // defaultValue={newData?.version_head}
                                    label="Version Head"
                                    onChange={handleVersionChange}
                                >
                                    {props.accessList.map((data, index) => {
                                        return (
                                            <MenuItem value={data.id}>{data.name}</MenuItem>
                                        )
                                    })}
                                </Select>
                            </FormControl> */}
                            <TextField
                                id='change_log'
                                fullWidth
                                autoComplete="off"
                                variant="outlined"
                                label="Latest Change"
                                onChange={handleVersionHeadChange}
                                // defaultValue={newData?.version}
                                sx={{ marginTop: "10px" }} />
                        </Box>
                    </DialogContent>
                    <DialogActions>
                        <Button color='primary' variant='contained' onClick={handleAddDialog} size='small'>
                            Close
                        </Button>
                        <Button disabled={addDisabled} color='primary' variant='contained' onClick={() => addVersion(newData)} size='small'>
                            Add
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog maxWidth="xs" fullWidth={true} open={editOpen}  >
                    <DialogTitle marginTop="2px" spacing={2}>Edit</DialogTitle>
                    <DialogContent>
                        {!oldData?.asset_source ? <>
                            <TextField
                                id='version_name'
                                fullWidth
                                autoComplete="off"
                                variant="outlined"
                                label="Version Name"
                                onChange={handleVersionHeadChange}
                                defaultValue={newData?.version_name}
                                sx={{ marginBottom: "10px" }} />
                        </> : null}
                        <TextField
                            id='version'
                            fullWidth
                            autoComplete="off"
                            variant="outlined"
                            label="Version"
                            onChange={handleVersionHeadChange}
                            defaultValue={newData?.version}
                            sx={{ marginBottom: "10px" }} />
                        {/* <FormControl variant="outlined" fullWidth>
                            <InputLabel id="version_head">Version Head</InputLabel>
                            <Select
                                variant="outlined"
                                labelId="demo-simple-select-label"
                                id="version_head"
                                defaultValue={newData?.version_head}
                                label="Version Head"
                                onChange={handleVersionChange}
                            >
                                {props.accessList.map((data, index) => {
                                    return (
                                        <MenuItem value={data.id}>{data.name}</MenuItem>
                                    )
                                })}
                            </Select>
                        </FormControl> */}
                        <TextField
                            id='change_log'
                            fullWidth
                            autoComplete="off"
                            variant="outlined"
                            label="Latest Change"
                            onChange={handleVersionHeadChange}
                            defaultValue={newData?.change_log}
                            sx={{ marginTop: "10px" }} />
                    </DialogContent>
                    <DialogActions>
                        <Button color='primary' variant='contained' onClick={closeEditDialog} size='small'>
                            Close
                        </Button>
                        <Button disabled={editDisabled} color='primary' variant='contained' onClick={editVersion} size='small'>
                            Edit
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog maxWidth="lg" fullWidth={true} open={openUpload}  >
                    <DialogTitle marginTop="2px" spacing={2}>Upload Blob</DialogTitle>
                    <DialogContent>
                        <Blob
                            obj={{ token_type: 'write_only', container_name: 'webgl-template' }}
                            maxSize={true}
                            containerName={"webgl-template/CLOUDGL" + selectedRow?.id}
                            fileName={selectedRow?.id}
                            filesType={props.data?.files_type}
                            version={selectedRow}
                            onClose={handleClose}
                            updateBlob={UpdateBlob} />
                    </DialogContent>
                </Dialog>
            </div>
        }</div>
    )
}

export default WebglUpload